<template>
<div class="next">
	<div class="van-nav-bar van-hairline--bottom custom-nav-bar">
		<div class="van-nav-bar__content">
			<div class="van-nav-bar__left van-haptics-feedback" @click="back()">
				<i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
			</div>
			<div class="van-nav-bar__title van-ellipsis">
				{{xuanfeidata.xuanfei_name || '加载中...'}}
			</div>
			<div class="van-nav-bar__right van-haptics-feedback"  @click="toService">
				<i class="van-badge__wrapper van-icon" style="font-size: 24px;">
					<img class="van-icon__image" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA4BJREFUWEfFlmnIpnMUxn/XF75Z840SgxAa2xiRJRnLkMlS82WSqcE09hBlnQxNQsaSyZJMmozsJNuMhvggGmQJKVtRJqbIJ5eux7nf7nk9z/vc91OaU/+e5f6fc677LNc5YhuLtrF/egGwfShwJHAIcHCdn4GP62yS9Gyfl+oEwPZuwBXAlcD2YxxsAO6W9EIXIGMB2F5ajvcGvgFWA1/X+QrYBdgHmAUcBSwux2uAFZI+nwnIjADK+f1l4AHgNkk/5bftHYH9gM2SAmggtk8DrgJOBD4C5jc6w4CMBGB7PvBiKS2UtNb2/sAlwEn11o3NP4EvgbWSVhaQO4BrgbeAMyX90RmA7YOAl4E9gBuB24Gby/kOY3L7LrAyNWB7HXAO8LSkc/sAWAFcBzwCXA88BiS0fWQJ8BLwarXLsZLemW5gaApsp3BSVGm1J4DD+nhu3b2hvi8H7pV02VgAts8C0svPAd8Bl07ovFGbC7wH5KXmSfq+be8/EbD9OLAIOBl4rafz5Hx6rp8EUjcp6oeBN1PQjd0pALbTz6n6o+thcndKTwDhgLTmNdP0Qk7Ht/7bSdLv+d0GcH4VW0+fU9fTiscACXGKLUBGyS2S0lVbAbipWm0SAJuB5ZLuKQ64PHT8fwLIAPqwdTZICoiB2J5dz3pFICFJFEbJRiD8PnAs6e+ZQmU7zLjviDtDUzATgCmFrvmxvQpY1gdAmOuhEQonSEoldxbbd9ZQis6WasVGfzBbphfhnsC3deOvotCQUmRnSb919v5vHYTGLyid04vQ5gHrJJ3X2BpGROnlp4A5wOt1cYGkMGNnsf0MsAB4VNJi2xcDtwKzJf0wEkDbg+0HgYuAsTVg+wDgQElhw0RgfZwBGUKf2P4iRCfp6raPLhvRL7WGzZX0Wct4IrKpjIV+TwWOC9fb3qu2pwHw2i0yX/L2n/YCUA7TnnMkTY1k2/nvDGBXIC2aZeSVup/8r5e0xvbuwPPAG5KyoGwlYyPQ3LadbTgg0l4jxXYKeZGkjba3q8Vmi6Szhyl1BtACMqu9A45CYjtrW0Z5tqq08dAu6g2gBSS8sRB4uxksFf7M/zzLKnZfjqQfRwGdCIDtbEgftIzeBRwOHAH8WqvYqqZoZ0rZpAAy29NmjaT1unsLymfnWUiABXq0HZCvVrShZ09TtoFkzoYpzdxBMYZ7vr8HyNeRjAaHC/gAAAAAElFTkSuQmCC">
					</i>
			</div>
		</div>
	</div>
	
	<!-- 加载状态 -->
	<div v-if="loading" class="loading-container">
		<van-loading type="spinner" size="24px">加载中...</van-loading>
	</div>
	
	<!-- 主要内容 -->
	<div v-else class="content">
		<div class="swiper">
			<swiper class="swiper" :options="bannerSwiperOption" v-if="xuanfeidata.img_url && xuanfeidata.img_url.length">
			  <swiper-slide v-for="(v,key) in xuanfeidata.img_url" :key="key">
					<img class="banner_img" :src="v" @error="retryImage" />
					<span class="premium-badge">
						<i>
							{{$t('home.gaoji')}}
						</i>
					</span>
			  </swiper-slide>
			</swiper>
			<div v-else class="image-placeholder">
				<van-empty description="暂无图片" />
			</div>
			
		  <div class="swiper-fot">
		  	<i class="van-badge__wrapper van-icon logo-icon">
		  		<img class="van-icon__image" src="img/logo.png">
			</i>
		  	<div class="verification-badges">
		  		<span class="badge">
		  			<i class="van-badge__wrapper van-icon">						
		  				<img class="van-icon__image" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAy9JREFUWEfdlk1IVFEUx//nOfaxKVpEgcsWSh/gwr5oUUb0tYjAdDFvtBZR2dyRgqLSeYPNGzWCEHxvJFplzhtBJXCVFfS1CCsjCGzRxz4K3LUp5514b7RGe3fem7EQust3zrn/3zn3nPsuYYkXLbE+lh5gUBd7yq1Cs2Y+WRhb6n7kBCjAPQArSgD5ZAMnZQAK8DjIXjZQ7x5Bpju2kXI8DGCTXyAzn18WUqymduOrzHe4O7Z2xuZGZqQ9fD7YNrLLubKvqbN3el4PWLr4DGBdMQiH2itzrxhLFx8BbCi0MehARDMezH2bD9B1tha28qYYAIFvhLX0Bb9KOXZLF9MA1sz5MtAT0cz2wtg/piCTjJ4jol6pAOO9mjCr/QCGktHtNtHE70xpPKwZhxbGeY6hpYvnAHbKRHLMO1oS6RfFILJ67CKDr//yYaVOTfS9DgaQiqlgzhQR6FQ182pxgOgIg465PoRbatw87eUvvYgsXdwHsN8ziDAZjptbZQDZblFj5/CWgErXR5J9nk2yhnRxxAbGZHYiPhGOpwe87BldpAjo8Mu+KIBjzKbEKDMaJBDPVM3cvdA2fO3S6pkf36YYqPLL3hfA6mqrh20/kp41oUmNmyOFdisZEyA2gmTvC+A4ZHRxm4DjXhAMHo9o6XmjZenCuUdqg2QfCGAoJepsxktpvyg4qHaYTsM6R9bAjNGg2QcCcJyspDBAEJKjuKtqptsnhZPDbG+LJPpfSY9v1hDoPZDtFDVcAefiWeW1oU32LgUUAtPTfPY0psaNo37igSvgllcX3Qxc8e4FDBA4BJDq2G2icHPcGPqrAAOpM1UVHJokYL3PxlPhuLGFiPivArgTkRQ9RLjss3FC1Uw9iHhJR+A4D+qt1QoqnDFbKRH4DiibVa3vwz8ByHd6tB+gVonAHVUzPe8MGVCgKSgMtlKxbWD2/BWzgsORDtN5XwZeJQPkqxDLAOx2/Nwi8POwlt4VWHnWsVyAfQA/nA+AtrBm5v8BJayyAPJVEM4runFWayqXm9nb0nnzSwnarmvZAC5EMnqKocwghIlIu/GuVPFFA5QjuDBmURX4LwB+Ajq/G9S6JXoiAAAAAElFTkSuQmCC">
		  				</i>
		  			{{$t('home.smrz')}}
		  		</span>
		  		<span class="badge">
		  			<i class="van-badge__wrapper van-icon">						
		  				<img class="van-icon__image" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAy9JREFUWEfdlk1IVFEUx//nOfaxKVpEgcsWSh/gwr5oUUb0tYjAdDFvtBZR2dyRgqLSeYPNGzWCEHxvJFplzhtBJXCVFfS1CCsjCGzRxz4K3LUp5514b7RGe3fem7EQust3zrn/3zn3nPsuYYkXLbE+lh5gUBd7yq1Cs2Y+WRhb6n7kBCjAPQArSgD5ZAMnZQAK8DjIXjZQ7x5Bpju2kXI8DGCTXyAzn18WUqymduOrzHe4O7Z2xuZGZqQ9fD7YNrLLubKvqbN3el4PWLr4DGBdMQiH2itzrxhLFx8BbCi0MehARDMezH2bD9B1tha28qYYAIFvhLX0Bb9KOXZLF9MA1sz5MtAT0cz2wtg/piCTjJ4jol6pAOO9mjCr/QCGktHtNtHE70xpPKwZhxbGeY6hpYvnAHbKRHLMO1oS6RfFILJ67CKDr//yYaVOTfS9DgaQiqlgzhQR6FQ182pxgOgIg465PoRbatw87eUvvYgsXdwHsN8ziDAZjptbZQDZblFj5/CWgErXR5J9nk2yhnRxxAbGZHYiPhGOpwe87BldpAjo8Mu+KIBjzKbEKDMaJBDPVM3cvdA2fO3S6pkf36YYqPLL3hfA6mqrh20/kp41oUmNmyOFdisZEyA2gmTvC+A4ZHRxm4DjXhAMHo9o6XmjZenCuUdqg2QfCGAoJepsxktpvyg4qHaYTsM6R9bAjNGg2QcCcJyspDBAEJKjuKtqptsnhZPDbG+LJPpfSY9v1hDoPZDtFDVcAefiWeW1oU32LgUUAtPTfPY0psaNo37igSvgllcX3Qxc8e4FDBA4BJDq2G2icHPcGPqrAAOpM1UVHJokYL3PxlPhuLGFiPivArgTkRQ9RLjss3FC1Uw9iHhJR+A4D+qt1QoqnDFbKRH4DiibVa3vwz8ByHd6tB+gVonAHVUzPe8MGVCgKSgMtlKxbWD2/BWzgsORDtN5XwZeJQPkqxDLAOx2/Nwi8POwlt4VWHnWsVyAfQA/nA+AtrBm5v8BJayyAPJVEM4runFWayqXm9nb0nnzSwnarmvZAC5EMnqKocwghIlIu/GuVPFFA5QjuDBmURX4LwB+Ajq/G9S6JXoiAAAAAElFTkSuQmCC">
		  				</i>
		  			{{$t('home.videorz')}}
		  		</span>
		  	</div>
		  </div>
		</div>
		
		<h1 class="section-title">
			{{xuanfeidata.xuanfei_name || '未知名称'}}
			<span class="serial-number" v-if="xuanfeidata.sn">
				{{xuanfeidata.sn}}
			</span>
		</h1>
		
		<div class="profile-section">
			<div class="profile-left">
				<h1 class="section-subtitle">
					{{$t('choose.jianjie')}}
				</h1>
				<p class="profile-info">
					{{$t('home.sg')}}: {{formatHeight(xuanfeidata.sg) || '未知'}} {{$t('home.xw')}}：{{xuanfeidata.xw || '未知'}}
				</p>
				<p class="profile-description" v-if="xuanfeidata.jianjie">
					{{xuanfeidata.jianjie}}
				</p>
				<div class="tags-container" v-if="xuanfeidata.tags_arr && xuanfeidata.tags_arr.length">
					<span 
						v-for="(val,index) in xuanfeidata.tags_arr" 
						:key="index" 
						class="tag"
						:class="`tag-${index % tagColors.length}`"
						:style="getTagStyle(index)"
					>
						{{val}}
					</span>
				</div>
				<div v-else class="no-tags">
					暂无标签
				</div>
				<p class="star-rating">
					{{$t('home.star')}}：
					<span v-for="(numa,indexs) in xuanfeidata.star || 0" :key="indexs" class="star"></span>
					<span v-if="!xuanfeidata.star" class="no-star">暂无评分</span>
				</p>
				<p class="profile-info">
					{{$t('choose.move')}}：{{$t('possible')}}
				</p>
			</div>
			<div class="profile-right">
				<span class="like-text">
					{{$t('thumb')}}
				</span>
			</div>
			<a class="action-button" @click="show=true" v-if="xuanfeidata.lottery">
				{{$t('choose.click')}}
			</a>
			<a class="action-button" @click="loadFallbackLottery(true)" v-else>
				加载玩法
			</a>
		</div>
		
		<div class="detail-section">
			<h1 class="section-subtitle">
				{{$t('choose.detail')}}
			</h1>
			<ul class="image-gallery" v-if="xuanfeidata.img_url && xuanfeidata.img_url.length">
				<li v-for="(v,key) in xuanfeidata.img_url" :key="key">
					<img :src="v" alt="" @error="retryImage">
				</li>			
			</ul>
			<div v-else class="no-images">
				<van-empty description="暂无详情图片" />
			</div>
			
			<div v-if="xuanfeidata.video_url">
				<h1 class="section-subtitle video-title">
					{{$t('choose.videodetail')}}
				</h1>
				<div class="video-container">
				  <video width="100%" controls :src="xuanfeidata.video_url"></video>
				</div>
			</div>
		</div>

		<div class="description-section">
			<h2 class="description-title">
				{{$t('privacyPolicy')}}
			</h2>
			<p class="description-content">
				{{$t('romanticDescription')}}
			</p>
		</div>
	</div>

	<van-popup
	  v-model="show"
	  class="profile-game-popup"
	  closeable
	  close-icon="close"
	  get-container="#app"
	  :style="{ height:'88%',width:'90%' }"
	  v-if="xuanfeidata.lottery"
	>
		<Game 
			:pkey="xuanfeidata.lottery.key" 
			:pid="xuanfeidata.lottery.id" 
			:ppic="xuanfeidata.img_url && xuanfeidata.img_url[0] ? xuanfeidata.img_url[0] : ''"
		/>
	</van-popup>
</div>
</template>

<script>
import Game from '../../common/Game'
import { formatHeightFromCm } from '../../common/height'
export default {
	components: {
	  Game
	},
	data() {
		return {
			xuanfeidata: {},
			show: false,
			loading: true,
			cover: "",
			bannerSwiperOption: {
			  loop: true,
			  speed:1000,
			  autoplay:true,
			  pagination: {
			    el: '.swiper-pagination'
			  },
			},
			// 定义多种颜色组合
			tagColors: [
				{ from: '#667eea', to: '#764ba2' },      // 蓝紫色
				{ from: '#f093fb', to: '#f5576c' },      // 粉红色
				{ from: '#4facfe', to: '#00f2fe' },      // 蓝色
				{ from: '#43e97b', to: '#38f9d7' },      // 绿色
				{ from: '#fa709a', to: '#fee140' },      // 橙粉色
				{ from: '#a8edea', to: '#fed6e3' },      // 浅蓝粉
				{ from: '#ff9a9e', to: '#fecfef' },      // 粉紫色
				{ from: '#a6c0fe', to: '#f68084' },      // 蓝粉色
				{ from: '#d4fc79', to: '#96e6a1' },      // 黄绿色
				{ from: '#84fab0', to: '#8fd3f4' },      // 青蓝色
				{ from: '#a3bded', to: '#6991c7' },      // 深蓝色
				{ from: '#fbc2eb', to: '#a6c1ee' }       // 紫粉色
			]
		};
	},
	methods: {
		hasKnownValue(value) {
			const normalized = String(value == null ? '' : value).trim().toLowerCase();
			return Boolean(normalized) && ![
				'未知', 'unknown', 'n/a', 'na', 'null', 'undefined', '-', '--'
			].includes(normalized);
		},
		formatHeight(value) {
			return formatHeightFromCm(value);
		},
		retryImage(event) {
			const image = event && event.target;
			if (!image || image.dataset.cacheRetried === '1') return;
			image.dataset.cacheRetried = '1';
			try {
				const url = new URL(image.currentSrc || image.src, window.location.href);
				url.searchParams.set('_image_retry', Date.now().toString());
				image.src = url.toString();
			} catch (error) {
				console.warn('Image retry failed:', error);
			}
		},
		back(){
		  return window.history.back();
		},
		toService(){
		  if(this.$store.getters.getBaseInfo.iskefu == 1){
		    this.$router.push("ServiceOnline");
		  }else {
		    this.$toast.fail(this.$t('common.noallow'));
		  }
		},
		getxuanfeidata() {
			this.loading = true;
			this.$http({
				method: 'get',
				url: 'xuanfeidata',
				data: { id: this.$route.query.id }
			}).then(async res => {
				this.xuanfeidata = this.normalizeProfile(res.data || {});
				this.cover = this.xuanfeidata.cover;
				if (!this.xuanfeidata.lottery) {
					await this.loadFallbackLottery(false);
				}
			}).catch(error => {
				console.error('获取数据失败:', error);
				this.$toast(this.$t('common.loadFailed'));
				this.xuanfeidata = {};
			}).finally(() => {
				this.loading = false;
			});
		},
		normalizeProfile(raw) {
			const localizedFlag = String(raw.flag || '').split('|')[0] || '';
			const tags = Array.isArray(raw.tags_arr)
				? raw.tags_arr
				: localizedFlag.split(/[,，、]/).map(v => v.trim()).filter(Boolean);
			return {
				...raw,
				sg: formatHeightFromCm(raw.sg || raw.hight || raw.height || ''),
				xw: raw.xw || raw.sw || raw.bust || '',
				star: Number(raw.star || raw.number || 0),
				class_name: raw.class_name || raw.address || raw.name || '',
				tags_arr: tags,
				video_url: raw.video_url || raw.pvideo || ''
			};
		},
		async loadFallbackLottery(openPopup = true) {
			try {
				const response = await this.$http({
					method: 'get',
					url: 'lottery_list'
				});
				const list = Array.isArray(response.data) ? response.data : [];
				if (list.length > 0) {
					this.$set(this.xuanfeidata, 'lottery', list[0]);
					if (openPopup) this.show = true;
				} else {
					this.$toast.fail('暂无可用玩法');
				}
			} catch (error) {
				console.error('加载玩法失败:', error);
				this.$toast.fail('加载玩法失败');
			}
		},
		yuyue() {
			this.$toast(this.$t('common.contactAdvisor'));
		},
		// 获取标签样式
		getTagStyle(index) {
			const colorIndex = index % this.tagColors.length;
			const color = this.tagColors[colorIndex];
			return {
				background: `linear-gradient(135deg, ${color.from}, ${color.to})`
			};
		},
		// 获取标签类名（用于CSS备用）
		getTagClass(index) {
			return `tag-${index % this.tagColors.length}`;
		}
	},
	created() {
		if(!localStorage.getItem('token')){
		  this.$router.push({path:'/Login'})
		}
		this.getxuanfeidata();
	}
};
</script>

<style scoped>
.custom-nav-bar .van-nav-bar__title {
	display: none !important;
}

/* 加载状态 */
.loading-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 200px;
}

/* 禁用状态按钮 */
.action-button.disabled {
	background: #ccc !important;
	cursor: not-allowed;
	opacity: 0.6;
}

.action-button.disabled:hover {
	transform: none !important;
	box-shadow: none !important;
}

/* 空状态样式 */
.no-tags,
.no-star,
.no-images,
.no-video {
	color: #999;
	font-size: 0.9rem;
	text-align: center;
	padding: 1rem;
}

.image-placeholder {
	height: 28rem;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f5f5f5;
}

/* 标签样式 - 使用动态类名 */
.tags-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin: 1rem 0;
}

.tag {
    color: #fff;
    display: inline-block;
    border-radius: .33333rem;
    margin-right: .33333rem;
    font-size: 12px;
    padding: .33333rem 1rem;
    margin-bottom: .33333rem;
    border: none;
    cursor: default;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.tag:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

/* 预定义的标签颜色类（备用） */
.tag-0 { background: linear-gradient(135deg, #667eea, #764ba2); }
.tag-1 { background: linear-gradient(135deg, #f093fb, #f5576c); }
.tag-2 { background: linear-gradient(135deg, #4facfe, #00f2fe); }
.tag-3 { background: linear-gradient(135deg, #43e97b, #38f9d7); }
.tag-4 { background: linear-gradient(135deg, #fa709a, #fee140); }
.tag-5 { background: linear-gradient(135deg, #a8edea, #fed6e3); }
.tag-6 { background: linear-gradient(135deg, #ff9a9e, #fecfef); }
.tag-7 { background: linear-gradient(135deg, #a6c0fe, #f68084); }
.tag-8 { background: linear-gradient(135deg, #d4fc79, #96e6a1); }
.tag-9 { background: linear-gradient(135deg, #84fab0, #8fd3f4); }
.tag-10 { background: linear-gradient(135deg, #a3bded, #6991c7); }
.tag-11 { background: linear-gradient(135deg, #fbc2eb, #a6c1ee); }

/* 导航栏样式 */
.custom-nav-bar {
    height: 3.5rem;
    line-height: 3.5rem;
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    position: relative;
    z-index: 10;
}

.custom-nav-bar::after {
    display: none;
}

.van-nav-bar__title {
    max-width: 60%;
    margin: 0 auto;
    color: white !important;
    font-weight: 600;
    font-size: 1.1rem;
}

.van-nav-bar__left {
    padding: 0 15px;
}

.van-nav-bar__arrow {
    color: white !important;
    font-size: 1.2rem;
    font-weight: bold;
}

.van-nav-bar__right .van-icon__image {
    filter: brightness(0) invert(1);
}

/* 轮播图区域 */
.swiper {
    width: 100%;
    position: relative;
}

.swiper .swiper-slide {
    height: min(68vh, 28rem);
    min-height: 20rem;
    overflow: hidden;
    position: relative;
}

.swiper .swiper-slide img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center 20%;
}

.premium-badge {
    position: absolute;
    z-index: 99;
    top: -5.33333rem;
    right: -8.66667rem;
    width: 10rem;
    height: 10rem;
    background: linear-gradient(135deg, #ff9f43, #ff6b6b);
    transform: rotate(45deg);
    opacity: 0.9;
}

.premium-badge i {
    position: absolute;
    bottom: 0;
    left: 1.83333rem;
    color: white;
    font-weight: 600;
}

/* 底部信息栏 */
.swiper-fot {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 2.66667rem;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 1.66667rem 1.66667rem 0 0;
    z-index: 9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2% 0 5%;
}

.logo-icon {
    display: none !important;
}

.verification-badges {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
}

.badge {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #ff9f43   , #ff6b6b   );
    color: white;
    font-weight: 600;
    margin-left: .2rem;
    padding: .2rem .6rem;
    font-size: 0.88rem;
}

.badge:first-child {
    border-radius: 0 0 0 1rem;
}

.badge:last-child {
    border-radius: 0 1rem 0 0;
}

/* 标题区域 */
.section-title {
    font-size: 18px;
    padding: 14px 0px;
    color: rgb(255, 255, 255);
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
}

.serial-number {
    margin-left: 10px;
    font-size: 16px;
}

/* 个人信息区域 */
.profile-section {
    display: flex;
    text-align: left;
    width: 100%;
    margin: 0 auto;
    padding: .33333rem 3%;
    position: relative;
    background: white;
    border-bottom: 1px solid #f0f0f0;
}

.profile-left {
    max-width: 100%;
    flex: 1;
}

.section-subtitle {
    padding: 0px 0px 10px;
    color: #333;
    font-size: 1rem;
    font-weight: 600;
}

.profile-info {
    font-size: .83333rem;
    color: #666;
    margin: 0.5rem 0;
}

.star-rating {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: .83333rem;
    color: #666;
}

.star {
    width: 1rem;
    height: 1rem;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%230f3460"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>') no-repeat 50%/100%;
    margin-left: 0.2rem;
}

.profile-right {
    position: absolute;
    right: 1.66667rem;
    text-align: center;
    color: #333;
    display: none;
}

.profile-right img {
    width: 3.66667rem;
    display: block;
}

.like-text {
    font-size: 0.8rem;
    color: #666;
}

.action-button {
    position: absolute;
    right: 1.66667rem;
    bottom: .66667rem;
    color: #fff;
    padding: .33333rem 1rem;
    background: linear-gradient(135deg, #ff9f43, #ff6b6b);
    border-radius: .33333rem;
    text-decoration: none;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    cursor: pointer;
}

.action-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* 详情区域 */
.detail-section {
    width: 100%;
    padding: .66667rem 3%;
    background: white;
}

.image-gallery {
    list-style: none;
    padding: 0;
    margin: 0;
}

.image-gallery li {
    margin-top: .33333rem;
}

.image-gallery li img {
    width: 100%;
    border-radius: 8px;
}

.video-title {
    padding-bottom: 0px;
}

.video-container {
    padding-top: 10px;
}

.video-container video {
    width: 100%;
    border-radius: 8px;
}

/* 描述区域 */
.description-section {
    text-align: left;
    padding: 1rem 3%;
    background: white;
}

.description-title {
    color: #2a1468;
    font-size: .93333rem;
    margin-bottom: 1rem;
}

.description-content {
    padding: .66633rem 0;
    color: #534589;
    line-height: 1.6;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .swiper .swiper-slide {
        height: 20rem;
    }
    
    .premium-badge {
        top: -4rem;
        right: -6rem;
        width: 8rem;
        height: 8rem;
    }
    
    .section-title {
        font-size: 16px;
        padding: 12px 0px;
    }
    
    .serial-number {
        font-size: 14px;
    }
    
    .tag {
        font-size: 11px;
        padding: .25rem .8rem;
    }
}

/* 动画效果 */
@keyframes fadeInUp {
    from { 
        opacity: 0; 
        transform: translateY(15px); 
    }
    to { 
        opacity: 1; 
        transform: translateY(0); 
    }
}

.profile-section,
.detail-section,
.description-section {
    animation: fadeInUp 0.4s ease forwards;
}

/* 人物详情：黑金轻奢主题 */
.next {
    min-height: 100vh;
    color: #f3eadb;
    background:
        linear-gradient(rgba(3, 5, 8, 0.8), rgba(3, 5, 8, 0.96)),
        url('../../assets/img/luxury-dating-bg-v2.png') center top / cover fixed no-repeat;
}

.custom-nav-bar {
    color: #efd18a;
    border-bottom: 1px solid rgba(218, 180, 105, 0.42);
    background: rgba(4, 6, 9, 0.97) !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.van-nav-bar__title,
.van-nav-bar__arrow {
    color: #efd18a !important;
}

.swiper {
    background: #080a0e;
}

.swiper .swiper-slide {
    border-bottom: 1px solid rgba(218, 180, 105, 0.3);
}

.swiper-fot {
    height: 3rem;
    border-top: 1px solid rgba(230, 196, 126, 0.22);
    border-radius: 1.4rem 1.4rem 0 0;
    background: linear-gradient(90deg, rgba(5, 7, 10, 0.9), rgba(16, 13, 9, 0.84));
    backdrop-filter: blur(10px);
}

.premium-badge {
    background: linear-gradient(135deg, #8e6228, #e2bd70);
}

.badge {
    padding: .3rem .7rem;
    color: #e9cb8f;
    font-size: .78rem;
    border: 1px solid rgba(226, 190, 116, 0.5);
    background: rgba(10, 12, 16, 0.9);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.32);
}

.section-title {
    padding: 13px 16px;
    color: #efd18a !important;
    font-size: 17px;
    letter-spacing: .5px;
    border-top: 1px solid rgba(218, 180, 105, 0.3);
    border-bottom: 1px solid rgba(218, 180, 105, 0.3);
    background: linear-gradient(100deg, rgba(7, 10, 14, 0.98), rgba(27, 21, 12, 0.94)) !important;
}

.profile-section {
    margin: 12px 12px 14px;
    width: auto;
    padding: 18px 16px 4.8rem;
    border: 1px solid rgba(218, 180, 105, 0.34);
    border-radius: 20px;
    background: linear-gradient(145deg, rgba(15, 18, 23, 0.94), rgba(6, 8, 12, 0.96));
    box-shadow: 0 16px 38px rgba(0, 0, 0, 0.42), inset 0 1px 0 rgba(255, 255, 255, 0.04);
    backdrop-filter: blur(12px);
}

.section-subtitle {
    padding-bottom: 12px;
    color: #e7c77f;
    font-size: 17px;
    letter-spacing: .5px;
}

.profile-info,
.star-rating {
    color: #d8cebd;
    font-size: 14px;
    line-height: 1.7;
}

.tags-container {
    margin: 12px 0;
}

.tag,
.tag-0,
.tag-1,
.tag-2,
.tag-3,
.tag-4,
.tag-5,
.tag-6,
.tag-7,
.tag-8,
.tag-9,
.tag-10,
.tag-11 {
    padding: 5px 10px;
    color: #e9cb8f;
    font-size: 12px;
    border: 1px solid rgba(218, 180, 105, 0.48);
    border-radius: 999px;
    background: rgba(194, 142, 55, 0.12);
    box-shadow: none;
}

.star {
    filter: sepia(1) saturate(2.2) brightness(1.35);
}

.no-tags,
.no-star,
.no-images,
.no-video {
    color: #a99e8d;
}

.action-button {
    right: 16px;
    bottom: 14px;
    min-width: 7.2rem;
    min-height: 2.9rem;
    padding: .7rem 1.35rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #171006;
    font-size: 1rem;
    font-weight: 750;
    letter-spacing: .04em;
    border: 1px solid rgba(247, 220, 160, 0.66);
    border-radius: 999px;
    background: linear-gradient(110deg, #a97732, #e7c87c, #bb853c);
    box-shadow: 0 .65rem 1.55rem rgba(185, 130, 48, 0.34), inset 0 1px 0 rgba(255,255,255,.25);
}

.detail-section,
.description-section {
    margin: 0 12px 14px;
    width: auto;
    padding: 15px;
    border: 1px solid rgba(218, 180, 105, 0.28);
    border-radius: 20px;
    color: #f3eadb;
    background: rgba(7, 10, 14, 0.93);
    box-shadow: 0 14px 34px rgba(0, 0, 0, 0.38);
}

.detail-section .section-subtitle {
    text-align: center;
    font-size: 18px;
}

.image-gallery li {
    margin-top: 10px;
}

.image-gallery li img,
.video-container video {
    display: block;
    border: 1px solid rgba(218, 180, 105, 0.34);
    border-radius: 16px;
    background: #080a0e;
    box-shadow: 0 10px 26px rgba(0, 0, 0, 0.34);
}

.description-title {
    color: #e7c77f;
}

.description-content {
    color: #d8cebd;
}

.image-placeholder {
    color: #aa9e8b;
    background: #090c10;
}

/* 详情资料使用 rem，防止 viewport 转换后字体过小 */
.profile-section .section-subtitle {
    padding-bottom: .75rem;
    font-size: 1.18rem;
    line-height: 1.4;
}

.profile-section .profile-info,
.profile-section .star-rating {
    margin: .72rem 0;
    font-size: 1rem;
    line-height: 1.65;
}

.profile-description {
    margin: .7rem 0;
    color: #cfc3b1;
    font-size: 1rem;
    line-height: 1.65;
}

.profile-section .tags-container {
    gap: .45rem;
    margin: .85rem 0;
}

.profile-section .tag,
.profile-section .tag-0,
.profile-section .tag-1,
.profile-section .tag-2,
.profile-section .tag-3,
.profile-section .tag-4,
.profile-section .tag-5,
.profile-section .tag-6,
.profile-section .tag-7,
.profile-section .tag-8,
.profile-section .tag-9,
.profile-section .tag-10,
.profile-section .tag-11 {
    margin: 0;
    padding: .42rem .72rem;
    font-size: .92rem;
    line-height: 1.25;
}

.profile-section .no-tags,
.profile-section .no-star {
    font-size: 1rem;
    line-height: 1.5;
}

.profile-section .star {
    width: 1.1rem;
    height: 1.1rem;
    margin-left: .28rem;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23f2c96d"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>');
    filter: drop-shadow(0 0 3px rgba(242, 201, 109, .35));
}

.profile-section .action-button {
    min-width: 8.4rem;
    min-height: 3.2rem;
    font-size: 1.15rem;
}

/* 320-430px：详情内容自然流式排列，消除绝对按钮和长文本叠压 */
@media (max-width: 430px) {
    .next {
        width: 100%;
        max-width: 100vw;
        min-height: 100dvh;
        padding-top: env(safe-area-inset-top);
        padding-bottom: calc(4.75rem + env(safe-area-inset-bottom));
        overflow-x: clip;
        background-attachment: scroll;
        box-sizing: border-box;
    }

    .next,
    .next * {
        box-sizing: border-box;
    }

    .custom-nav-bar {
        width: 100%;
        min-height: 3.25rem;
        height: clamp(3rem, 14vw, 3.5rem);
        line-height: normal;
    }

    .custom-nav-bar .van-nav-bar__content {
        height: 100%;
        min-height: 3.25rem;
    }

    .custom-nav-bar .van-nav-bar__left,
    .custom-nav-bar .van-nav-bar__right {
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        padding: 0 .85rem;
    }

    .content {
        width: 100%;
        min-width: 0;
    }

    .swiper {
        max-width: 100%;
        overflow: hidden;
    }

    .swiper .swiper-slide {
        height: clamp(17rem, 88vw, 22rem);
        min-height: 0;
    }

    .image-placeholder {
        height: clamp(17rem, 88vw, 22rem);
    }

    .swiper-fot {
        min-height: 3rem;
        height: auto;
        padding: .4rem .55rem;
        border-radius: 1rem 1rem 0 0;
    }

    .verification-badges {
        min-width: 0;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: .3rem;
    }

    .verification-badges .badge {
        min-width: 0;
        max-width: 100%;
        margin-left: 0;
        padding: .3rem .5rem;
        font-size: .72rem;
        line-height: 1.2;
        text-align: center;
        white-space: normal;
        overflow-wrap: anywhere;
        border-radius: .55rem;
    }

    .premium-badge {
        top: -4.25rem;
        right: -6.25rem;
        width: 8rem;
        height: 8rem;
    }

    .premium-badge i {
        left: 1.45rem;
        max-width: 5rem;
        font-size: .72rem;
        line-height: 1.15;
        text-align: center;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .section-title {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: .25rem .6rem;
        min-width: 0;
        margin: 0;
        padding: .75rem;
        font-size: 1.05rem;
        line-height: 1.35;
        overflow-wrap: anywhere;
    }

    .serial-number {
        max-width: 100%;
        margin-left: 0;
        font-size: .88rem;
        overflow-wrap: anywhere;
    }

    .profile-section {
        display: block;
        width: auto;
        margin: .75rem;
        padding: 1rem;
        border-radius: 1.15rem;
    }

    .profile-left {
        width: 100%;
        min-width: 0;
    }

    .profile-section .section-subtitle {
        padding-bottom: .6rem;
        font-size: 1.05rem;
        overflow-wrap: anywhere;
    }

    .profile-section .profile-info,
    .profile-section .profile-description,
    .profile-section .star-rating {
        max-width: 100%;
        margin: .6rem 0;
        font-size: .92rem;
        line-height: 1.55;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .profile-section .star-rating {
        flex-wrap: wrap;
        gap: .1rem;
    }

    .profile-section .tags-container {
        align-items: flex-start;
        gap: .35rem;
        margin: .7rem 0;
    }

    .profile-section .tag,
    .profile-section .tag-0,
    .profile-section .tag-1,
    .profile-section .tag-2,
    .profile-section .tag-3,
    .profile-section .tag-4,
    .profile-section .tag-5,
    .profile-section .tag-6,
    .profile-section .tag-7,
    .profile-section .tag-8,
    .profile-section .tag-9,
    .profile-section .tag-10,
    .profile-section .tag-11 {
        max-width: 100%;
        padding: .38rem .6rem;
        font-size: .82rem;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .profile-section .action-button {
        position: static;
        width: 100%;
        min-width: 0;
        min-height: 3rem;
        margin-top: .9rem;
        padding: .65rem .85rem;
        font-size: 1rem;
        line-height: 1.3;
        text-align: center;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .detail-section,
    .description-section {
        width: auto;
        min-width: 0;
        margin: 0 .75rem .75rem;
        padding: .85rem;
        border-radius: 1.15rem;
    }

    .detail-section .section-subtitle,
    .description-title {
        margin: 0;
        font-size: 1.05rem;
        line-height: 1.4;
        overflow-wrap: anywhere;
    }

    .image-gallery li {
        margin-top: .6rem;
    }

    .image-gallery li img,
    .video-container video {
        width: 100%;
        height: auto;
        border-radius: .85rem;
    }

    .description-content {
        padding: .55rem 0 0;
        font-size: .9rem;
        line-height: 1.6;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .profile-game-popup {
        width: calc(100vw - 1.5rem) !important;
        max-width: 32rem;
        height: calc(100vh - 1.5rem - env(safe-area-inset-top) - env(safe-area-inset-bottom)) !important;
        max-height: none;
        overflow-x: hidden;
        overflow-y: auto;
        border-radius: 1.25rem;
        overscroll-behavior: contain;
    }

    .profile-game-popup ::v-deep .van-popup__close-icon {
        top: max(.8rem, env(safe-area-inset-top));
        right: .8rem;
        z-index: 5;
    }
}

@supports (height: 100dvh) {
    @media (max-width: 430px) {
        .profile-game-popup {
            height: calc(100dvh - 1.5rem - env(safe-area-inset-top) - env(safe-area-inset-bottom)) !important;
        }
    }
}

@media (max-width: 350px) {
    .swiper .swiper-slide,
    .image-placeholder {
        height: clamp(16rem, 92vw, 19rem);
    }

    .profile-section {
        margin: .55rem;
        padding: .8rem;
    }

    .detail-section,
    .description-section {
        margin-right: .55rem;
        margin-left: .55rem;
        padding: .75rem;
    }
}

@supports not (overflow: clip) {
    @media (max-width: 430px) {
        .next {
            overflow-x: hidden;
        }
    }
}
</style>
